import TablaConciliacion from "../../../TablaConciliacion";

function TablaUnionDelSur() {
  return <TablaConciliacion nombreUseCase="UNIONDELSUR" titulo="UNION DEL SUR" />;
}

export default TablaUnionDelSur;
